
import { css } from 'lit';
export default css`
.share {
  position: relative;
  display: flex;
  justify-content: flex-end;
}@media (min-width: 1024px) {.share {
    display: block;
  }
}.share__icon {
  height: 1rem;
}.share__icon {
  width: 1rem;
}.share__icon {
    cursor: pointer;
    margin-left: 12px;
  }.share__button {
  position: relative;
}.share__button {
  z-index: 30;
}.share__button {
  display: flex;
}.share__button {
  align-items: center;
}.share__button {
  font-weight: 700;
}.share__button {
    cursor: pointer;
  }.share__button:hover {
  text-decoration: underline;
}.share__button.active .share__menu {
  display: flex;
}.share__button.active .share__menu + .share__overlay {
  position: fixed;
}.share__button.active .share__menu + .share__overlay {
  top: 0px;
}.share__button.active .share__menu + .share__overlay {
  bottom: 0px;
}.share__button.active .share__menu + .share__overlay {
  left: 0px;
}.share__button.active .share__menu + .share__overlay {
  right: 0px;
}.share__button.active .share__menu + .share__overlay {
  z-index: 10;
}.share__button.active .share__menu + .share__overlay {
  background-color: transparent;
}.share__button-link {
  font-weight: 700;
}.share__button-link {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 60;
      font-size: 18px;
    }.share__menu {
  position: absolute;
}.share__menu {
  bottom: 0px;
}.share__menu {
  z-index: 50;
}.share__menu {
  display: none;
}.share__menu {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}.share__menu {
  padding: 1rem;
}.share__menu {
    left: auto;
    right: 0;
    top: 48px;
    height: 56px;
    transform: none;
    box-shadow: 0px 3px 5px rgb(0 0 0 / 15%);
  }.share__menu:before {
  position: absolute;
}.share__menu:before {
  margin: auto;
}.share__menu:before {
  height: 0px;
}.share__menu:before {
  width: 0px;
}.share__menu:before {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}.share__menu:before {
      content: "";
      top: -28px;
      border-left: 14px solid transparent;
      border-top: 14px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 14px solid;
      left: 86px;
    }@media (min-width: 1024px) {.share__menu:before {
        left: 54px
    }
      }@media (min-width: 1024px) {.share__menu {
      right: auto;
      left: -15px
  }
    }.share__item-wrapper {
  margin-right: 1rem;
}.share__item-wrapper:last-child {
  margin-right: 0px;
}.share__item {
  display: flex;
}.share__item {
  align-items: center;
}.share__item-icon {
  height: 1.5rem;
}.share__item-icon {
  width: 1.5rem;
}.share__item-icon {
  fill: currentColor;
}.share__item-icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}.share__item-icon:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}.share--purple .share__icon {
      width: 24px;
      height: 21px;
      margin-left: 12px;
    }.share--purple .share__menu::before {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}.share--purple .share__button-link {
  fill: currentColor;
}.share--purple .share__button-link {
  font-weight: 900;
}.share--purple .share__button-link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}.share--purple .share__button-link {
      font-size: 18px;
      text-transform: uppercase;
      letter-spacing: 2px;
    }.share--purple .share__button-link:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}@media (min-width: 1024px) {.share--purple .share__button-link {
        justify-content: flex-end
    }
      }.share--share-print .share__menu {
      left: -15px;
      right: auto;
    }.share--share-print .share__menu:before {
        left: 54px;
      }
`;